import { render } from "./BaseSpinner.vue?vue&type=template&id=aaaf4c92&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=aaaf4c92&scoped=true&lang=css"

import exportComponent from "C:\\Users\\leste\\OneDrive\\Desktop\\Target-Innovations\\01-Active-Projects\\Target - marido-en-alquiler-web-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaaf4c92"]])

export default __exports__